'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Container, Row, Col, Button, ListGroup } from 'reactstrap';
import CtaBtn from 'shared/components/CtaBtn';
import JobTeaser from 'shared/components/JobTeaser';
import { usePathname, useRouter } from 'next/navigation';
import Pager from 'shared/components/Pager';
import { Locale, SynergiejobsDictionary } from 'shared/i18n/i18n-config';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import AppLayout from '../../../components/AppLayout';

type Props = {
  jobs: Job[];
  count: number;
  totalPages: number;
  page: number;
  dictionary: SynergiejobsDictionary;
  locale: Locale;
};

export default function FlexiJobs({ jobs, count, totalPages, page, dictionary, locale }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { push } = useRouter();
  const pathname = usePathname();

  function gotoJobs() {
    const jobsContainer = document.getElementById('jobsSection');
    if (jobsContainer) jobsContainer.scrollIntoView();
    else push(`/jobs`);
  }

  const handlePageChange = (newPage: number) => {
    const newPath = `${pathname}?page=${newPage}`;
    push(newPath, { scroll: false });
    gotoJobs();
  };
  const firstJob = page * 10 - 9;
  const lastJob = page * 10 > count ? count : page * 10;

  return (
    <AppLayout
      dictionary={dictionary}
      id="flexi-jobs"
      className="parallax-wrapper"
      availableLocales={[
        { locale: 'nl', pathname: `/flexi-jobs/` },
        { locale: 'fr', pathname: `/flexi-jobs/` },
      ]}
      noSpacer
    >
      <div id="flexi-jobs-container" className="preserve3d">
        {/* Header */}
        <Container fluid className="mt-4 mt-lg-0 bg-white px-0 px-lg-5">
          <div className="width-1320 mx-auto">
            <Row className="position-relative">
              <Col id="header-text" className="mb-4" lg={{ size: 5 }}>
                <div className="mx-2">
                  <h1 className="mt-3 mt-lg-0 mb-3">{formatMessage({ id: 'flexi_header_title' })}</h1>
                  <p>{formatMessage({ id: 'flexi_header_text' })}</p>
                  <Link href="#jobsSection">
                    <CtaBtn className="btn btn-primary cta red my-3" type="button">
                      {formatMessage({ id: 'flexi_header_cta' })}
                    </CtaBtn>
                  </Link>
                </div>
              </Col>
              <Col lg={{ offset: 3, size: 9 }} className="p-0">
                <Image
                  width={1932}
                  height={1304}
                  className="img-fluid flexi-img"
                  src="/images/flexi-jobs/Rectangle 184.jpg"
                  alt="a smiling salesperson hands over a satchel"
                />
              </Col>
            </Row>
          </div>
        </Container>
        {/* Buttons */}
        <Container fluid className="bg-white d-flex justify-content-center py-5 px-lg-5">
          <Row className="buttonContainer d-flex justify-content-center align-items-center">
            <Col className="d-none d-lg-block me-1">
              <hr className="line" />
            </Col>
            <Col xs={12} lg="auto" className="d-flex justify-content-center">
              <Row className="d-flex align-items-center gx-0 w-100">
                <Col xs={6} md={3} lg="auto" className="p-1">
                  <Link href="#flexi-what">
                    <Button outline className="w-100">
                      {formatMessage({ id: 'flexi_btn_what' })}
                    </Button>
                  </Link>
                </Col>
                <Col xs={6} md={3} lg="auto" className="p-1">
                  <Link href="#flexi-who">
                    <Button outline className="w-100">
                      {formatMessage({ id: 'flexi_btn_who' })}
                    </Button>
                  </Link>
                </Col>
                <Col xs={6} md={3} lg="auto" className="p-1">
                  <Link href="#flexi-where">
                    <Button outline className="w-100">
                      {formatMessage({ id: 'flexi_btn_where' })}
                    </Button>
                  </Link>
                </Col>
                <Col xs={6} md={3} lg="auto" className="p-1">
                  <Link href="#flexi-advantages">
                    <Button outline className="w-100">
                      {formatMessage({ id: 'flexi_btn_advantages' })}
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Col>
            <Col className="d-none d-lg-block ms-1">
              <hr className="line" />
            </Col>
          </Row>
        </Container>
        {/* what */}
        <Container fluid className="preserve3d no-padding-x width-1920">
          <section className="preserve3d parallax-group" id="flexi-what">
            <Row style={{ margin: '0', padding: '0' }} className="preserve3d">
              <Col lg={6} className="p-0 preserve3d">
                <div className="parallax-layer-what">
                  <Image
                    width={1728}
                    height={1116}
                    className="img-fluid flexi-img"
                    src="/images/flexi-jobs/Rectangle 176.jpg"
                    alt="a happy cook prepares a meal"
                  />
                </div>
              </Col>
              <Col
                lg={6}
                className="textbox-container-what d-flex flex-column justify-content-center align-items-center align-items-xxl-start bg-red ms-auto"
              >
                <div className="textbox my-5 px-3 px-md-4 px-lg-5 px-xxl-0">
                  <h2 className="mb-4">{formatMessage({ id: 'flexi_what_title' })}</h2>
                  <p className="mb-4">{formatMessage({ id: 'flexi_what_text' })}</p>
                  <Link href="#jobsSection">
                    <CtaBtn className="cta white outline" type="button">
                      {formatMessage({ id: 'flexi_header_cta' })}
                    </CtaBtn>
                  </Link>
                </div>
              </Col>
            </Row>
          </section>{' '}
        </Container>
        {/* who */}
        <Container fluid className="bg-white" id="flexi-who">
          <section className="text-section width-1320 mx-auto px-sm-3 px-md-4 px-lg-5 px-xxl-0">
            <Row style={{ margin: '0', padding: '0' }}>
              <Col xs={12} lg={6} className="mb-4 mb-lg-0 p-0">
                <h2 className="mb-0 me-5">{formatMessage({ id: 'flexi_who_title' })}</h2>
              </Col>
              <Col xs={12} lg={6} className="text-section-body p-0">
                <ul className="mb-4 mb-lg-0">
                  <li className="mb-3">{formatMessage({ id: 'flexi_who_bullet1' })}</li>
                  <li className="mb-3">{formatMessage({ id: 'flexi_who_bullet2' })}</li>
                  <li className="mb-3">{formatMessage({ id: 'flexi_who_bullet3' })}</li>
                  <li className="mb-3">{formatMessage({ id: 'flexi_who_bullet4' })}</li>
                  <li className="mb-3">
                    {formatMessage(
                      { id: 'flexi_who_bullet5' },
                      {
                        link: (
                          <a href={`https://mycareer.be/${locale}`} target="_blank" rel="noopener noreferrer">
                            {formatMessage({ id: 'flexi_who_bullet4_link' })}
                          </a>
                        ),
                      }
                    )}
                  </li>
                </ul>
                <Link href={`/${locale}/jobs?contractTypes=contract-type-flexi`} className="d-block d-lg-none">
                  <CtaBtn className="cta outline" type="button">
                    {formatMessage({ id: 'flexi_header_cta' })}
                  </CtaBtn>
                </Link>
              </Col>
            </Row>
          </section>
        </Container>
        <Container fluid className="parallax-group preserve3d no-padding-x width-1920 img-wide">
          <div className="parallax-layer-wide">
            <Image
              width={3456}
              height={1040}
              className="img-fluid flexi-img"
              src="/images/flexi-jobs/Rectangle 178.jpg"
              alt="a baker finishes off some pastries"
            />
          </div>
        </Container>
        {/* where */}
        <Container fluid className="bg-white" id="flexi-where">
          <section className="text-section width-1320 mx-auto px-sm-3 px-md-4 px-lg-5 px-xxl-0">
            <Row style={{ margin: '0', padding: '0' }}>
              <Col xs={12} lg={6} className="mb-4 mb-lg-0 p-0">
                <h2 className="mb-0 me-5">{formatMessage({ id: 'flexi_where_title' })}</h2>
              </Col>
              <Col xs={12} lg={6} className="text-section-body p-0">
                <p className="mb-3">{formatMessage({ id: 'flexi_where_text1' })}</p>
                <ul className="ps-0 ms-0">
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet1' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet2' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet3' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet4' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet5' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet6' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet7' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet8' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet9' })}</li>
                  <li className="mb-1">{formatMessage({ id: 'flexi_where_bullet10' })}</li>
                  <li className="mb-1">...</li>
                </ul>
                <p>
                  {formatMessage(
                    { id: 'flexi_where_text3' },
                    {
                      link: <Link href={`/${locale}/agencies`}>{formatMessage({ id: 'flexi_where_text3_link' })}</Link>,
                    }
                  )}
                </p>
              </Col>
            </Row>
          </section>
        </Container>
        <Container fluid className="parallax-group preserve3d no-padding-x width-1920 img-wide">
          <div className="parallax-layer-wide">
            <Image
              width={3456}
              height={1092}
              className="img-fluid flexi-img"
              src="/images/flexi-jobs/Rectangle 179.jpg"
              alt="a cashier smiling into the camera"
            />
          </div>
        </Container>
        {/* Advantages */}
        <Container fluid className="bg-white" id="flexi-advantages">
          <section className="text-section width-1320 mx-auto px-sm-3 px-md-4 px-lg-5 px-xxl-0">
            <Row style={{ margin: '0', padding: '0' }}>
              <Col xs={12} lg={6} className="mb-4 mb-lg-0 p-0">
                <h2 className="mb-0 me-5">{formatMessage({ id: 'flexi_advantages_title' })}</h2>
              </Col>
              <Col xs={12} lg={6} className="text-section-body p-0">
                <ul className="ps-0 ms-0">
                  <li className="mb-3">{formatMessage({ id: 'flexi_advantages_bullet1' })}</li>
                  <li className="mb-3">{formatMessage({ id: 'flexi_advantages_bullet2' })}</li>
                  <li>{formatMessage({ id: 'flexi_advantages_bullet3' })}</li>
                </ul>
              </Col>
            </Row>
          </section>
        </Container>
        {/* how much */}
        <Container fluid className="preserve3d no-padding-x width-1920">
          <section className="preserve3d parallax-group" id="flexi-how-much">
            <Row style={{ margin: '0', padding: '0' }} className="preserve3d">
              <Col lg={{ size: 6, order: 2 }} className="p-0 preserve3d">
                <div className="parallax-layer-how-much">
                  <Image
                    width={1748}
                    height={2280}
                    className="img-fluid flexi-img"
                    src="/images/flexi-jobs/Rectangle 181.jpg"
                    alt="a baker handling a rack full of freshly baked bread"
                  />
                </div>
              </Col>
              <Col
                lg={{ size: 6, order: 1 }}
                className="textbox-container-how-much d-flex flex-column justify-content-center align-items-center align-items-xxl-start bg-red"
              >
                <div className="textbox my-5 px-3 px-md-4 px-lg-5 px-xxl-0">
                  <h2 className="mb-4">{formatMessage({ id: 'flexi_how_much_title' })}</h2>
                  <ul className="ps-0 ms-0">
                    <li className="mb-3">{formatMessage({ id: 'flexi_how_much_bullet1' })}</li>
                    <li className="mb-3">{formatMessage({ id: 'flexi_how_much_bullet2' })}</li>
                    <li className="mb-3">
                      {formatMessage(
                        { id: 'flexi_how_much_bullet3' },
                        {
                          link: (
                            <a
                              href={
                                locale === 'nl'
                                  ? 'https://www.sfpd.fgov.be/nl/pensioenbedrag/bijverdienen'
                                  : 'https://www.sfpd.fgov.be/fr/montant-de-la-pension/travailler'
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {formatMessage({ id: 'flexi_how_much_bullet3_link' })}
                            </a>
                          ),
                        }
                      )}
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </section>
        </Container>
        {/* Find flexi-jobs */}
        <div style={{ backgroundColor: 'white' }}>
          <Container fluid className="no-padding-x width-1920 bg-light text-section">
            <section className="width-1320 mx-auto px-sm-3 px-md-4 px-lg-5 px-xxl-0">
              <Row style={{ margin: '0', padding: '0' }}>
                <Col xs={12} lg={6} className="mb-4 mb-lg-0 p-0">
                  <h2 className="mb-0 me-5">{formatMessage({ id: 'flexi_find_title' })}</h2>
                </Col>
                <Col xs={12} lg={6} className="text-section-body p-0">
                  <p className="mb-3">{formatMessage({ id: 'flexi_find_text1' })}</p>
                  <p className="mb-5">{formatMessage({ id: 'flexi_find_text2' })}</p>
                  <Link href={`/${locale}/agencies`}>
                    <CtaBtn className="cta red" type="button">
                      {formatMessage({ id: 'flexi_our_agencies' })}
                    </CtaBtn>
                  </Link>
                </Col>
              </Row>
            </section>
          </Container>
        </div>
        {/* jobs */}
        {jobs && jobs.length > 0 && (
          <section id="jobsSection">
            <Container className="mt-lg-5 mb-lg-5 mt-4 mb-4">
              <Row>
                <Col md={12}>
                  <h2 className="mb-5">{formatMessage({ id: 'jobpage-info' }, { from: firstJob, to: lastJob, total: count })}</h2>
                  <ListGroup>
                    {jobs.map((flexiJob) => (
                      <JobTeaser job={flexiJob} dictionary={dictionary} key={flexiJob.id} titleTag="h3" />
                    ))}
                  </ListGroup>
                  <Pager className="mt-3" currentPage={page} totalPages={totalPages} changePage={handlePageChange} />
                </Col>
              </Row>
            </Container>
          </section>
        )}
      </div>
    </AppLayout>
  );
}
